<div class="row">
    <div id="map"></div>
</div>
